export default "__VITE_ASSET__VapHDEgD__"